import Vue from 'vue';

//Letting meta head from mixins to be be properly merged with page level head
//be sure to use function: head() { return {}; }
let strategies = Vue.config.optionMergeStrategies;
strategies.head = strategies.data;
